import cn from 'classnames';
import { IoClose } from 'react-icons/io5';
import ReactModal from 'react-modal';

import modalStyles from '../GenericModal/GenericModal.module.scss';

import AppRatingView from './AppRatingModalForm';
import styles from './styles.module.scss';

export default function AppRatingModal({ isModalOpen, onSuccessfulSubmit, onClose }) {
  return (
    <ReactModal
      className={styles.content}
      overlayClassName={modalStyles.overlay}
      portalClassName={styles.modal}
      isOpen={isModalOpen}
      onRequestClose={onClose}
      contentLabel="Rating"
      ariaHideApp={false}
    >
      <div className={cn(styles.header, modalStyles.headerClass)}>
        <button type="button" className={styles.closeBtn} onClick={onClose}>
          <IoClose className={modalStyles.closeSymbol} />
        </button>
      </div>

      <div className={cn([styles.body, 'fullBody'])}>
        <div className={styles.container}>
          <AppRatingView onSuccessfulSubmit={onSuccessfulSubmit} />
        </div>
      </div>

      <div className={styles.footer} />
    </ReactModal>
  );
}
